/*常量文件*/

//待办事项状态
const todo_status = [
  { Key: 0, Text: "待处理" },
  { Key: 1, Text: "已处理", Color: "#080" },
];

//银行到账公示状态
const bankReceived_collected_status = [
  { Key: 0, Text: "待认领" },
  { Key: 1, Text: "认领中", Color: "#1e90ff" },
  { Key: 2, Text: "已认领", Color: "#080" },
];

//银行到账认领记录状态
const bankcollected_status = [
  { Key: 0, Text: "待确认" },
  { Key: 1, Text: "已确认", Color: "#1e90ff" },
  { Key: 2, Text: "已取消", Color: "#a2a2a2" },
  { Key: 3, Text: "已撤回", Color: "#ffa500" },
];

//到账合并记录状态
const bankreceivedmerge_status = [
  { Key: 0, Text: "待审核" },
  { Key: 1, Text: "审核通过", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

//工资表员工明细算税状态
const payrollemployee_tax_status = [
  { Key: 0, Text: "未算税" },
  { Key: 1, Text: "算税中", Color: "#1e90ff" },
  { Key: 2, Text: "已算税", Color: "#080" },
  { Key: 3, Text: "算税失败", Color: "#f00" },
  { Key: 999, Text: "异常", Color: "#f00" },
];

//外协算税单状态
const calctaxoutsource_status = [
  { Key: 0, Text: "算税中", Color: "#1e90ff" },
  { Key: 1, Text: "已算税", Color: "#080" },
  { Key: 2, Text: "已取消", Color: "#a2a2a2" },
];

//工资表员工明细发放状态
const payrollemployee_pay_status = [
  { Key: 0, Text: "未发放" },
  { Key: 1, Text: "已申请", Color: "#ffa500" },
  { Key: 2, Text: "发放中", Color: "#1e90ff" },
  { Key: 3, Text: "已发放", Color: "#080" },
  { Key: 4, Text: "发放失败", Color: "#f00" },
];

//算税单状态
const calctax_status = [
  { Key: 0, Text: "算税中", Color: "#1e90ff" },
  { Key: 1, Text: "已算税", Color: "#ffa500" },
  { Key: 2, Text: "已取消", Color: "#a2a2a2" },
];

//算税单提交算税状态
const calctax_is_submit = [
  { Key: 0, Text: "未提交" },
  { Key: 1, Text: "数据校验中", Color: "#ffa500" },
  { Key: 2, Text: "已提交", Color: "#a2a2a2" },
];

//发薪审核状态
const salaryapply_status = [
  { Key: 0, Text: "待审核" },
  { Key: 1, Text: "审核通过", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

//发薪审核进度(正常发放进度)
const salaryapply_step = [
  { Key: 1, Text: "业务待审", Color: "#2979F2" },
  { Key: 2, Text: "财务待审", Color: "#E67E22" },
  { Key: 3, Text: "总经理待审", Color: "#5E35B1" },
  { Key: 4, Text: "审核通过", Color: "#080" },
  { Key: 5, Text: "审核不通过", Color: "#f00" },
];

//发薪审核进度(欠款发放进度)
const salaryapply_step_qk = [
  { Key: 0, Text: "业务待审", Color: "#2979F2" },
  { Key: 1, Text: "财务待审", Color: "#E67E22" },
  { Key: 2, Text: "审核通过", Color: "#080" },
];

//开票记录状态
const invoiceapply_status = [
  { Key: 0, Text: "待开票" },
  { Key: 1, Text: "已开票", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

//扣缴义务人在税局的注册状态
const withholdingagent_pts_status = [
  { Key: 0, Text: "未注册", Color: "#a2a2a2" },
  { Key: 1, Text: "注册成功", Color: "#080" },
  { Key: 2, Text: "注册失败", Color: "#f00" },
];

//薪酬发放单状态
const salarypayment_status = [
  { Key: 0, Text: "待发放", color: "#000" },
  { Key: 1, Text: "发放中", Color: "#1e90ff" },
  { Key: 2, Text: "部分发放", Color: "#ffa500" },
  { Key: 3, Text: "已完成", Color: "#080" },
  { Key: 4, Text: "已撤回", Color: "#a2a2a2" },
];

//薪酬发放单银企接口调用状态
const salarypayment_interface_status = [
  { Key: 0, Text: "无需调用", color: "#a2a2a2" },
  { Key: 1, Text: "待调用接口", Color: "#000" },
  { Key: 2, Text: "已调用接口", Color: "#1e90ff" },
  { Key: 3, Text: "调用成功", Color: "#080" },
];

//薪酬发放单员工列表发放状态
const salarypayment_record_status = [
  { Key: 0, Text: "未发放", color: "#a2a2a2" },
  { Key: 1, Text: "已申请", Color: "#000" },
  { Key: 2, Text: "发放中", Color: "#1e90ff" },
  { Key: 3, Text: "已发放", Color: "#080" },
  { Key: 4, Text: "发放失败", Color: "#f00" },
];

//薪酬发放单日志状态
const salarypayment_log_status = [
  { Key: 0, Text: "待处理", color: "#000" },
  { Key: 1, Text: "已处理", Color: "#080" },
  { Key: 2, Text: "系统异常", Color: "#f00" },
];

//异卡发放审核状态
const diffbank_check_status = [
  { Key: 0, Text: "待审核" },
  { Key: 1, Text: "已审核", Color: "#080" },
  { Key: 2, Text: "已驳回", Color: "#f00" },
];

//员工减除费用扣除操作记录状态
const deductionamount_log_status = [
  { Key: -1, Text: "待执行" },
  { Key: 0, Text: "已发送请求，待回执", Color: "#1e90ff" },
  { Key: 1, Text: "请求成功", Color: "#080" },
];

//员工报送状态
const employeedeclare_declare_status = [
  { Key: -1, Text: "报送中", Color: "#1e90ff" },
  { Key: 0, Text: "未报送" },
  { Key: 1, Text: "已报送", Color: "#080" },
  { Key: 2, Text: "报送失败", Color: "#f00" },
];

//员工报-送人员验证状态
const employeedeclare_verify_status = [
  { Key: -1, Text: "待验证" },
  { Key: 0, Text: "验证不通过", Color: "#f00" },
  { Key: 1, Text: "验证通过", Color: "#080" },
  { Key: 2, Text: "失败", Color: "#f00" },
];

//开票记录状态
const invoice_status = [
  { Key: 0, Text: "待开票" },
  { Key: 1, Text: "已开票", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

//个税申报-申报类型
const taxdeclare_declare_type = [
  { Key: 1, Text: "综合所得", Color: "#1e90ff" },
  { Key: 2, Text: "分类所得", Color: "#080" },
  { Key: 3, Text: "非居民所得", Color: "#ffa500" },
  { Key: 4, Text: "限售股所得", Color: "#f00" },
];

//个税申报状态
const taxdeclare_status = [
  { Key: -1, Text: "申报中" },
  { Key: 0, Text: "待申报", Color: "#080" },
  { Key: 1, Text: "已申报", Color: "#080" },
];

//工资发放明细类型
const salaryrecordemployee_type = [
  { Key: 0, Text: "平台代发", Color: "#1e90ff" },
  { Key: 1, Text: "人工代发", Color: "#080" },
  { Key: 2, Text: "供应商代发", Color: "#ffa500" },
];

//税款缴纳操作记录状态
const taxpay_log_status = [
  { Key: -1, Text: "待调用接口" },
  { Key: 0, Text: "待获取接口结果", Color: "#1e90ff" },
  { Key: 1, Text: "接口结果成功", Color: "#080" },
  { Key: 2, Text: "失败情况", Color: "#f00" },
];

//税款缴纳欠费状态状态
const taxpay_qfzt = [
  { Key: 0, Text: "欠费查询成功", Color: "#080" },
  { Key: 1, Text: "校验失败", Color: "#f00" },
  { Key: 2, Text: "无欠费记录", Color: "#1e90ff" },
  { Key: 3, Text: "欠费查询请求失败", Color: "#f00" },
];

//外协工资发放单状态
const salarypaymentoutsource_status = [
  { Key: 0, Text: "发放中", Color: "#1e90ff" },
  { Key: 1, Text: "发放成功", Color: "#080" },
  { Key: 2, Text: "发放失败", Color: "#f00" },
  { Key: 3, Text: "部分发放失败", Color: "#ffa500" },
];

//发薪查询-发薪方式
const salaryrecord_type = [
  { Key: 0, Text: "平台代发", color: "#1e90ff" },
  { Key: 1, Text: "人工代发", Color: "#080" },
  { Key: 2, Text: "供应商代发", Color: "#ffa500" },
];

//发薪查询-发薪单状态
const salaryrecord_status = [
  { Key: 0, Text: "待发放", color: "#000" },
  { Key: 1, Text: "发放中", Color: "#1e90ff" },
  { Key: 2, Text: "部分发放", Color: "#ffa500" },
  { Key: 3, Text: "已完成", Color: "#080" },
  { Key: 4, Text: "已撤回", Color: "#a2a2a2" },
];

//申诉记录处理状态
const ptsmessage_is_deal = [
  { Key: 0, Text: "待处理", Color: "#1e90ff" },
  { Key: 1, Text: "处理成功", Color: "#080" },
  { Key: 2, Text: "处理失败", Color: "#f00" },
];

//退付手续费状态
const ptscommission_status = [
  { Key: 0, Text: "未确认" },
  { Key: 1, Text: "确认成功", Color: "#080" },
  { Key: 2, Text: "确认失败", Color: "#f00" },
];

//退付手续费申请状态
const ptscommission_sqzt = [
  { Key: "01", Text: "退税成功", Color: "#080" },
  { Key: "02", Text: "银行卡不对", Color: "#f00" },
  { Key: "03", Text: "审核不通过", Color: "#f00" },
  { Key: "04", Text: "审核申请中", Color: "#ffa500" },
  { Key: "05", Text: "审核通过，手续费退付中", Color: "#1e90ff" },
  { Key: "06", Text: "未申请退付" },
  { Key: "07", Text: "退库复核同意", Color: "#080" },
  { Key: "08", Text: "收入退还书送交国库", Color: "#080" },
];

//退付手续费操作记录状态
const ptscommission_log_status = [
  { Key: -1, Text: "待调用接口" },
  { Key: 0, Text: "待获取接口结果", Color: "#1e90ff" },
  { Key: 1, Text: "接口结果成功", Color: "#080" },
  { Key: 2, Text: "失败情况", Color: "#f00" },
];

//服务费计算方式
const service_cost_type_data = [
  "固定金额",
  "每次固定服务费",
  "（实发+个税）*6.2%",
  "（社保+公积金+商险+实发+个税）*6.5%",
  "固定+（实发+个税）*7%",
  "固定+应发*7% （备注：固定服务费，7%是税费）",
  "（应发-代扣项目）*6.2%",
  "固定（备注：服务费是从员工工资里面进行扣除）",
  "应发*6.87%（备注：6.87%税费，无服务费）",
  "应发*10%（取整数）",
  "工资*12%",
];

//复核算税状态
const recalctaxemployee_status = [
  { Key: 0, Text: "待复核" },
  { Key: 1, Text: "复核中", Color: "#1e90ff" },
  { Key: 2, Text: "已复核", Color: "#080" },
];

//税款缴纳缴款状态
const taxpay_pay_type = [
  { Key: 0, Text: "未发起缴款" },
  { Key: 1, Text: "三方协议", Color: "#1e90ff" },
  { Key: 2, Text: "银联", Color: "#080" },
];

//未算税员工处理状态
const uncalctaxemployee_deal_status = [
  { Key: 0, Text: "未处理" },
  { Key: 1, Text: "处理中", Color: "#1e90ff" },
  { Key: 2, Text: "已处理", Color: "#080" },
  { Key: 3, Text: "处理失败", Color: "#f00" },
];

//工资更正单状态
const taxdeclarecorrect_status = [
  { Key: 0, Text: "更正中", Color: "#1e90ff" },
  { Key: 1, Text: "已完成", Color: "#080" },
];

//申报确认状态
const declareconfirm_zt = [
  { Key: 0, Text: "未发送", color: "#000" },
  { Key: 1, Text: "待确认", Color: "#1e90ff" },
  { Key: 2, Text: "同意", Color: "#080" },
  { Key: 3, Text: "不同意", Color: "#ffa500" },
  { Key: 9, Text: "失败", Color: "#f00" },
];

//银企类型
const b2e_type = [
  { Key: "boc", Text: "中国银行" },
  { Key: "icbc", Text: "中国工商银行" },
  { Key: "cmbc", Text: "中国民生银行" },
];

//汇算清缴报表状态
const taxfinalsettlement_status = [
  { Key: -1, Text: "待调用接口", Color: "#409EFF" },
  { Key: 0, Text: "待获取接口结果", Color: "#E6A23C" },
  { Key: 1, Text: "接口结果成功,", Color: "#67C23A" },
  { Key: 999, Text: "接口结果失败", Color: "#F56C6C" }, //值大于1统一视为结果失败
];

//汇算清缴报表详情状态
const taxfinalsettlement_detail_zt = [
  { Key: 1, Text: "成功", Color: "#67C23A" },
  { Key: 2, Text: "失败", Color: "#F56C6C" },
  { Key: 3, Text: "处理中", Color: "#E6A23C" },
];

//汇算清缴报表详情申报状态
const taxfinalsettlement_detail_sbzt = [
  { Key: 1, Text: "已经申报", Color: "#67C23A" },
  { Key: 0, Text: "未申报" },
];

//汇算清缴报表详情退补税类型
const taxfinalsettlement_detail_tbslx = [
  { Key: 1, Text: "补税", Color: "#1e90ff" },
  { Key: 2, Text: "退税", Color: "#E6A23C" },
  { Key: 3, Text: "不需要退补税" },
];

//外籍员工属性-涉税事项
const employee_sssx = [
  "任职受雇",
  "提供临时劳务",
  "转让财产",
  "从事投资和经营活动",
  "其他",
];

export default {
  todo_status,
  bankReceived_collected_status,
  service_cost_type_data,
  bankcollected_status,
  payrollemployee_tax_status,
  payrollemployee_pay_status,
  calctaxoutsource_status,
  salaryapply_status,
  salaryapply_step,
  salaryapply_step_qk,
  invoiceapply_status,
  salarypayment_status,
  salarypayment_interface_status,
  salarypayment_record_status,
  diffbank_check_status,
  deductionamount_log_status,
  employeedeclare_declare_status,
  employeedeclare_verify_status,
  invoice_status,
  calctax_status,
  calctax_is_submit,
  taxdeclare_declare_type,
  taxdeclare_status,
  salaryrecordemployee_type,
  taxpay_log_status,
  salarypaymentoutsource_status,
  salaryrecord_type,
  salaryrecord_status,
  ptsmessage_is_deal,
  ptscommission_status,
  ptscommission_sqzt,
  ptscommission_log_status,
  withholdingagent_pts_status,
  salarypayment_log_status,
  recalctaxemployee_status,
  taxpay_qfzt,
  taxpay_pay_type,
  uncalctaxemployee_deal_status,
  taxdeclarecorrect_status,
  bankreceivedmerge_status,
  declareconfirm_zt,
  b2e_type,
  taxfinalsettlement_status,
  taxfinalsettlement_detail_zt,
  taxfinalsettlement_detail_sbzt,
  taxfinalsettlement_detail_tbslx,employee_sssx
};
